import '@fpsm/cxy-tokens/tokens.css';

import { useRef } from 'react';

import { useLayoutStore } from '~/providers/layout-store-provider';

import { ArticleLoginWall } from './ArticleLoginWall/ArticleLoginWall';
import { useLoginWall } from './hooks/useLoginWall';
import { handleClick } from './utils/handleClick';
import styles from './InlineHtml.module.css';

export const InlineHtml = ({ componentTags, html }: { componentTags?: string[]; html: string }) => {
  const containerRef = useRef<HTMLDivElement>(null);

  const resourcesUrl = useLayoutStore(s => s.resourcesUrl);

  const { myocData, shouldRenderLoginWall } = useLoginWall({
    componentTags,
    containerRef,
  });

  return shouldRenderLoginWall ? (
    <ArticleLoginWall myocData={myocData} resourcesUrl={resourcesUrl} />
  ) : (
    <div
      className={styles.inlineHtmlWrapper}
      dangerouslySetInnerHTML={{ __html: html }}
      data-testid="inline-html-div"
      onClick={handleClick}
      ref={containerRef}
    />
  );
};
